<template>
  <div id="app">
    <b-card header="<i class='fa fa-magnifier'></i> Browse BL/AWB">
      <div class="row">
        <div class="mx-3">
          <input type="text" placeholder="Pencarian" class="form-control" v-model="searchFilter">
        </div>
        <div class="ml-auto pr-3 pb-3" >
          <router-link to="/rekonmanifes/add"> <button type="button" class="btn btn-success" name="button" router > <i class="fa fa-plus"></i> Tambah File</button></router-link>

        </div>
      </div>      
      <div class="row">
        <div class="col-12">
          <table class="table table-bordered">
            <thead>
              <tr style="cursor: pointer">
                <th @click="sort('NM_PERUSAHAAN')">Nama Perusahaan <i class="fa fa-arrows-v pull-right"></i> </th>
                <th @click="sort('no_bl')">Nomor AWB/BL <i class="fa fa-arrows-v pull-right"></i></th>
                <th @click="sort('tgl_bl')">Tanggal <i class="fa fa-arrows-v pull-right"></i></th>
                <th @click="sort('jn_perusahaan')">Pengirim <i class="fa fa-arrows-v pull-right"></i></th>
                <th @click="sort('jn_perusahaan')">Jenis Dokumen <i class="fa fa-arrows-v pull-right"></i></th>
                <th @click="sort('wk_kirim')">Waktu Kirim <i class="fa fa-arrows-v pull-right"></i></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="bl in pageOfItems" :key="bl.id_rekon_manifes">
                <td>{{bl.NM_PERUSAHAAN}}</td>
                <td>{{bl.no_bl}}</td>
                <td>{{bl.tgl_bl}}</td>
                <td>{{bl.jn_perusahaan == 1 ? 'PJT' : (bl.jn_perusahaan == 2 ? 'Agen Pengangkut' : 'Bea Cukai')}}</td>
                <td>{{bl.kd_tujuan == 1 ? 'LDP-KB' : (bl.jn_dokumen == 2 ? 'KB-TLDDP' : '-')}}</td>
                <td>{{bl.wk_kirim}}</td>
                <td>
                  <a :href="$http.options.base+bl.file_directory+'/'+bl.file" class="btn btn-warning" target="_blank"> <i class="fa fa-download"></i> </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="ml-3 pb-0 pt-3">
            <jw-pagination :items="filteredData" @changePage="onChangePage"></jw-pagination>
        </div>        
      </div>
    </b-card>
  </div>
</template>
<script>
export default {
  data () {
    return {
      searchFilter: '',
      pageOfItems: [],
      listBL: [],
      currentSort: 'wk_kirim',
      currentSortDir: 'asc'
      // url: this.$http.options.root
    }
  },
  computed: {
    // dataNhiFiltered () {
    //   return this.datanhi.filter((nhi) => {
    //     return this.searchFilter.toLowerCase().split(' ').every(v => nhi.no_container.toLowerCase().includes(v))
    //   })
    // },
    filteredData: function () {
      return this.listBL.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      }).filter((items) => {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1) {
            return true
          }
        }
        return false
      })
    }
  },
  mounted () {
    this.browse()
  },
  methods: {
    sort: function (s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    browse () {
      var data = {
        npwp: this.$store.getters['auth/user']['npwp']
      }
      this.$http.post('rekonmanifes/browse', data).then((response) => {
        this.listBL = response.data
        // this.isLoading = false
      })
    },
    onChangePage (pageOfItems) {
    // update page of items
      this.pageOfItems = pageOfItems
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/RekonManifes/browsebl.vue?4c574d2c